"use client";
import { jsx as a, jsxs as w } from "react/jsx-runtime";
import { useHover as b, useMergedRef as k, Box as N, Paper as v, AnimatedButton as x, sharedHandler as y } from "@ingeniorforeningen/figurine-core";
import { forwardRef as I } from "react";
import R from "./variants/CardContact.js";
import S from "./variants/CardDefault.js";
import j from "./variants/CardImage.js";
import H from "./variants/CardSelectable.js";
import B from "./variants/CardSpot.js";
import '../../../assets/Card.css';const L = "_root_dulct_2", P = "_paper_dulct_19", $ = "_button_dulct_24", n = {
  root: L,
  paper: P,
  button: $
}, s = I((i, m) => {
  const { cta: t, variant: r = "default", fluid: p, onClick: d, mod: f, className: u, ...o } = i, e = { ...o }, c = r !== "contact", l = r === "spot", { ref: C } = b(), h = k(C, m), _ = (g) => {
    d && d(g), c && t && window && (t.target ? window.open(t.href, t.target) : window.location.href = t.href);
  };
  return delete e.subject, delete e.header, delete e.text, delete e.image, delete e.contactList, delete e.name, delete e.onSelectChange, /* @__PURE__ */ a(
    N,
    {
      ...e,
      className: `${n.root} ${u}`,
      onClick: _,
      mod: { "with-link": c, fluid: p, ...f },
      children: /* @__PURE__ */ w(
        v,
        {
          variant: l ? "secondary" : "primary",
          p: "xs",
          className: n.paper,
          ref: h,
          children: [
            r === "contact" ? /* @__PURE__ */ a(R, { ...o }) : r === "image" ? /* @__PURE__ */ a(j, { ...o }) : r === "spot" ? /* @__PURE__ */ a(B, { ...o }) : r === "selectable" ? /* @__PURE__ */ a(H, { ...o }) : /* @__PURE__ */ a(S, { ...o }),
            t && r !== "selectable" && /* @__PURE__ */ a(
              x,
              {
                link: t,
                variant: l ? "light" : "dark",
                className: n.button
              }
            )
          ]
        }
      )
    }
  );
});
s.displayName = "Card";
const A = y(s);
A.displayName = s.displayName;
export {
  n as C,
  s as _Card,
  A as default
};
